module.exports = __webpack_public_path__ + "img/ropbanner.ec172beb.jpg";